import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

export const magData = {
  // --- MAG MODELS (ALPHABETIZED) ---
  mags: [
    { id: "1911_45", name: "1911 45 ACP Single Stack", depth_profile: "standard_only" },
    { id: "arex_alpha", name: "AREX Alpha", qs_mag: true, depth_profile: "all" },
    { id: "arex_delta", name: "AREX DELTA (1.0 / 2.0 M)", qs_mag: true, depth_profile: "all" },
    { id: "arex_delta_l", name: "AREX DELTA L", qs_mag: true, depth_profile: "all" },
    { id: "arex_zero", name: "AREX Zero", qs_mag: true, depth_profile: "all" },
    { id: "beretta_80x", name: "Beretta 80x Cheetah", depth_profile: "standard_only" },
    { id: "beretta_92_m9", name: "Beretta 92/M9 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "browning_hp", name: "Browning Hi-Power 9mm", qs_mag: true, depth_profile: "all" },
    { id: "canik_940", name: "Canik 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "cz_75", name: "CZ 75 Series", qs_mag: true, depth_profile: "all" },
    { id: "cz_97b", name: "CZ 97B 45", depth_profile: "standard_only" },
    { id: "cz_p_series", name: "CZ P07/P09/P10 Series (NOT P10 S)", qs_mag: true, depth_profile: "all" },
    { id: "cz_p10s", name: "CZ P10 S", qs_mag: true, depth_profile: "all" },
    { id: "fn_57", name: "FN 5.7 (Old Gen)", depth_profile: "standard_only" }, 
    { id: "fn_503", name: "FN 503", depth_profile: "standard_only" },
    { id: "fn_509_c", name: "FN 509 C", qs_mag: true, depth_profile: "all" },
    { id: "fn_509_series", name: "FN 509 Series (NOT 509C)", qs_mag: true, depth_profile: "all" },
    { id: "fn_510", name: "FN 510", depth_profile: "standard_only" },
    { id: "fn_fnx45", name: "FN FNX 45", depth_profile: "standard_only" },
    { id: "fns_940", name: "FNS 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "fnx_940", name: "FNX 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "glock_large", name: "Glock 20 / 21 / 30 / 41 (10mm/45)", depth_profile: "standard_only" },
    { id: "glock_26", name: "Glock 26", qs_mag: true, depth_profile: "standard_only" },
    { id: "glock_36", name: "Glock 36", depth_profile: "standard_only" },
    { id: "glock_42", name: "Glock 42", depth_profile: "standard_only" },
    { id: "glock_43", name: "Glock 43", depth_profile: "standard_only" },
    { id: "glock_slim", name: "Glock 43X/48 series", qs_mag: true, depth_profile: "all" },
    { id: "glock_slim_15", name: "Glock 43X/48 series (15 RND ONLY)", qs_mag: true, depth_profile: "all" },
    { id: "glock_940_357", name: "Glock 9/40/357SIG Series", qs_mag: true, depth_profile: "all" },
    { id: "hk_cc9", name: "HK CC9", qs_mag: true, depth_profile: "all" },
    { id: "hk_p30", name: "HK P30 Series", qs_mag: true, depth_profile: "all" },
    { id: "hk_usp_9", name: "HK USP 9MM", qs_mag: true, depth_profile: "all" },
    { id: "hk_usp_c_9", name: "HK USP Compact 9MM", qs_mag: true, depth_profile: "all" },
    { id: "hk_vp_940", name: "HK VP 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "hk_vp_9CC", name: "HK VP 9CC", qs_mag: true, depth_profile: "all" },
    { id: "iwi_masada_9", name: "IWI Masada 9mm", qs_mag: true, depth_profile: "all" },
    { id: "iwi_masada_slim", name: "IWI Masada Slim", qs_mag: true, depth_profile: "all" },
    { id: "kahr_cm9", name: "Kahr CM9", depth_profile: "standard_only" },
    { id: "kimber_evo", name: "Kimber EVO SP", depth_profile: "standard_only" },
    { id: "psa_rock", name: "PSA Rock 5.7", depth_profile: "standard_only" },
    { id: "ruger_lc9", name: "Ruger LC9", depth_profile: "standard_only" },
    { id: "ruger_sr22", name: "Ruger SR22 (Standard)", depth_profile: "standard_only" },
    { id: "sccy_cpx_940", name: "SCCY CPX 9/40", qs_mag: true, depth_profile: "all" },
    { id: "sccy_cpx1", name: "SCCY CPX-1", qs_mag: true, depth_profile: "all" },
    { id: "sccy_cpx3", name: "SCCY CPX-3", qs_mag: true, depth_profile: "all" },
    { id: "sccy_dvg", name: "SCCY DVG-1RD", qs_mag: true, depth_profile: "all" },
    { id: "sig_2022", name: "Sig Pro 2022 9/40", qs_mag: true, depth_profile: "all" },
    { id: "sig_p226_9", name: "SIG P226 9mm Series", qs_mag: true, depth_profile: "all" },
    { id: "sig_p229_9", name: "SIG P229 9mm Series", qs_mag: true, depth_profile: "all" },
    { id: "sig_p238", name: "Sig Sauer P238", depth_profile: "standard_only" },
    { id: "sig_p320_940", name: "SIG P320/P320C 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "sig_p365_xl", name: "SIG P365/XL(P365x)", qs_mag: true, depth_profile: "standard_only" },
    { id: "sig_p938", name: "Sig P938", depth_profile: "standard_only" },
    { id: "sig_xmacro_17", name: "SIG XMACRO 17 RND", qs_mag: true, depth_profile: "all" },

    // --- SMITH & WESSON (Unified Naming & Alphabetized) ---
    { id: "sw_bodyguard_2", name: "S&W Bodyguard 2.0", depth_profile: "standard_only" },
    { id: "sw_mp45", name: "S&W M&P 45", depth_profile: "standard_only" },
    { id: "sw_mp_940_357", name: "S&W M&P/2.0 9/40/357SIG Series (NOT SHIELD)", qs_mag: true, depth_profile: "all" },
    { id: "sw_shield_45", name: "S&W Shield 45", depth_profile: "standard_only" },
    { id: "sw_shield_9", name: "S&W Shield 9mm (Original)", depth_profile: "standard_only" },
    { id: "sw_shield_plus", name: "S&W Shield Plus", qs_mag: true, depth_profile: "all" },
    { id: "sw_shield_x", name: "S&W Shield X", qs_mag: true, depth_profile: "all" }, // Added Shield X

    { id: "springfield_xd9", name: "Springfield XD9", qs_mag: true, depth_profile: "all" },
    { id: "xd_s_45", name: "Springfield XDs 45", depth_profile: "standard_only" },
    { id: "xd_s_9", name: "Springfield XDs 9mm", depth_profile: "standard_only" },
    { id: "staccato_ds", name: "Staccato 9mm Double Stack (DOES NOT FIT CS)", qs_mag: true, depth_profile: "staccato" },
    { id: "staccato_cs", name: "Staccato CS", qs_mag: true, depth_profile: "staccato" },
    { id: "steyr_a2", name: "Steyr A2", qs_mag: true, depth_profile: "all" },
    { id: "taurus_pt111", name: "Taurus PT111 G2", depth_profile: "standard_only" },
    { id: "walther_ccp", name: "Walther CCP 9/40", depth_profile: "standard_only" },
    { id: "walther_pdp_940", name: "Walther PDP 9/40", qs_mag: true, depth_profile: "all" },
    { id: "walther_ppq_940", name: "Walther PPQ 9/40 Series", qs_mag: true, depth_profile: "all" },
    { id: "walther_pps_m2", name: "Walther PPS M2 9/40", depth_profile: "standard_only" }
  ],

  // --- CONFIGURATIONS ---
  configurations: [
    { id: "owb_left", name: "Outside Waistband - Left Side Carry/Rounds Facing Forward" },
    { id: "owb_right", name: "Outside Waistband - Right Side Carry/Rounds Facing Forward" },
    { id: "iwb_left", name: "Inside Waistband - Left Side Carry/Rounds Facing Forward" },
    { id: "iwb_right", name: "Inside Waistband - Right Side Carry/Rounds Facing Forward" }
  ],

  // --- DEPTH OPTIONS (FILTERED BY PROFILE) ---
  depth_options: [
    { id: "standard", name: "Standard Depth", price: 0 },
    { id: "standard_adj", name: "Standard Adjustable", price: 0 },
    { id: "deep", name: "Deep", price: 0 },
    { id: "deep_adj", name: "Deep Adjustable", price: 0 }
  ],

  // --- COLORS ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 10),

  // --- MOUNTS ---
  mounts: [
    { 
      id: "clip_15", 
      name: "1.5\" Injection Molded Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/mag/fomo_clip_front.png", 
      img_layer_mount_back: "/images/mounts/mag/fomo_clip_back.png",
      description: "Standard injection molded clip. Durable, reliable, reverse tab."
    },
    { 
      id: "clip_175", 
      name: "1.75\" Injection Molded Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/mag/fomo175_clip_front.png", 
      img_layer_mount_back: "/images/mounts/mag/fomo_clip_back.png",
      description: "Standard injection molded clip for wider belts."
    },
    { 
      id: "dcc_ANRlogo", 
      name: "1.5\" DCC ANR Logo", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/mag/dccanrlogo_front.png", 
      img_layer_mount_back: "/images/mounts/mag/dccanrlogo_back.png",
      description: "Heat treated steel alloy. High clamping force."
    },
    { 
      id: "dcc_TOPOlogo", 
      name: "1.5\" DCC TOPO", 
      price: 8.25, 
      img_layer_mount: "/images/mounts/mag/dcctopo_front.png", 
      img_layer_mount_back: "/images/mounts/mag/dcctopo_back.png",
      description: "Heat treated steel alloy with TOPO design."
    },
    { 
       id: "dcc_tigerstripe", 
       name: "1.5\" DCC Tiger Stripe", 
       price: 8.25, 
       img_layer_mount: "/anr-builder/images/mounts/mag/dcctigerstripe_front.png", 
       img_layer_mount_back: "/anr-builder/images/mounts/mag/dcctigerstripe_back.png",
       description: "Heat treated steel alloy with Tiger Stripe design."
    },
    // --- ADDED DCC NO LOGO HERE ---
    { 
      id: "dcc_nologo", 
      name: "1.5\" DCC No Logo", 
      price: 6.25, 
      img_layer_mount: "/images/mounts/mag/dcc_nologo_front.png", 
      img_layer_mount_back: "/images/mounts/mag/dcc_nologo_back.png",
      description: "Heat treated steel alloy. Clean, no logo finish."
    },
    { 
      id: "dcc_FDElogo", 
      name: "1.5\" DCC FDE", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/mag/dccfde_front.png", 
      img_layer_mount_back: "/images/mounts/mag/dccfde_back.png",
      description: "Heat treated steel alloy in FDE."
    },
    { 
      id: "neomag", 
      name: "NeoMag Alias TPost", 
      price: 15.99, 
      img_layer_mount: "/images/mounts/mag/neomag_front.png",
      description: "Premium clip-less system. Requires NeoMag Alias belt receiver."
    },
    {
      id: "neomag_receiver", 
      name: "NeoMag Alias TPost and Neomag Receiver", 
      price: 49.99, 
      img_layer_mount: "/images/mounts/mag/neomagreciever_front.png",
      description: "Includes Neomag T Post + Receiver Addon for belt."
    }
  ],

  // --- WARRANTIES ---
  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};